import { Questionnaire } from '../model/questionnaire';
import { Question } from '../model/question';
import { Choice } from '../model/choice';
import {TSMap} from 'typescript-map';

export class QuestionnaireUtil {

    static clone(questionnaire: Questionnaire) {
        const q = new Questionnaire();
        q.id = questionnaire.id;
        q.email = questionnaire.email;
        let i: number;
        for (i = 0; i < questionnaire.languages.length; i++) {
            q.languages.push(questionnaire[i]);
        }


        for (i = 0; i < questionnaire.questions.length; i++) {
            const question = new Question();

            for (let j = 0; j < questionnaire.questions[i].choices.length; j++) {
                const c = new Choice();
                c.answer =  questionnaire.questions[i].choices[j].answer;

                for (const key in questionnaire.questions[i].choices[j].texts.keys()) {
                  if(questionnaire.questions[i].choices[j].texts.has(key)) {
                    c.texts.set(key,questionnaire.questions[i].choices[j].texts.get(key));
                  }
                }

                question.choices.push(c);
            }

            question.no = questionnaire.questions[i].no;

            question.texts = new TSMap<string,string>();

            for (const key in questionnaire.questions[i].texts.keys()) {
              if(questionnaire.questions[i].choices[i].texts.has(key)) {
                question.texts.set(key, questionnaire.questions[i].texts.get(key));
              }
            }

            question.toSave = questionnaire.questions[i].toSave;
            question.type = questionnaire.questions[i].type;
            question.validator = questionnaire.questions[i].validator;

            q.questions.push(question);
        }

        q.sms = questionnaire.sms;
        q.name = questionnaire.name;

        return q;
    }

    static isResponsesEquals(q1:Questionnaire, q2:Questionnaire) {
        if (q1.questions.length !== q2.questions.length) {
            return false;
        }

        for (let i = 0; i < q1.questions.length; i++) {

            if (q1.questions[i].choices.length !== q2.questions[i].choices.length) {
                return false;
            }

            for (let j = 0; j < q1.questions[i].choices.length; j++) {
                if (q1.questions[i].choices[j].answer !== q2.questions[i].choices[j].answer) {
                    return false;
                }
            }
        }

        return true;
    }
}
